/**
 * The second of two discriminated 200 bodies from `POST /v1/auth/token`.
 * Carries no `access_token` key at all -- absent, not null -- so a caller
 * that ignores `mfa_required` reads `undefined`, not something coercible.
 */
export interface MfaChallenge {
  mfa_required: true;
  /**
   * Half-authenticated credential, ~5 minutes, no permissions. NgRx state
   * only: never stored, never a Bearer.
   */
  mfa_token: string;
  /** Seconds until the challenge row expires, not a token lifetime. */
  expires_in: number;
  methods: MfaMethod[];
  scope: 'mfa';
}

/** The complete set the backend emits (`MFA_METHODS` in `dtos/mfa_dto.py`). */
export type MfaMethod = 'totp' | 'email';

/** `POST /v1/auth/mfa/challenge/email`, HTTP 202. */
export interface MfaEmailSendResult {
  sent: boolean;
  masked_email: string;
  expires_at: string;
  /** Before this, a resend is refused with a 429. */
  next_allowed_at: string;
}

/**
 * Keys off `mfa_required`, not a missing `access_token`, so a body carrying
 * both would still read as a challenge.
 */
export function isMfaChallenge(
  body: unknown
): body is MfaChallenge {
  return !!body && (body as MfaChallenge).mfa_required === true;
}
